import { createModule } from '../../createModule';
import { parseInput } from '../../shared';
import * as FeedsSchemas from './feeds.schemas';
export const createFeedsAPI = createModule(({ http }) => ({
    getProviders: async (params) => {
        const res = await http.get(`/v2/feeds/providers`, {
            params,
        });
        return res;
    },
    getNT: async (params) => {
        const res = await http.get(`/v2/feeds/provider/nt`, {
            params,
        });
        return res;
    },
    getTableData: async (params) => {
        const { provider_id, feed_id, ...otherParams } = params;
        const res = await http.get(`/v2/feeds/data/${provider_id}/${feed_id}`, {
            params: otherParams,
        });
        return res;
    },
    getICGuidelines: async (params) => {
        const res = await http.get(`/v2/feeds/posmon`, {
            params,
        });
        return res;
    },
    getScheduledTaskList: async () => {
        const res = await http.get('/v2/feeds/scheduled-tasks/list');
        return res;
    },
    getFeedsList: async () => {
        const res = await http.get('/v2/feeds/scheduled-tasks/feed-list');
        return res;
    },
    runScheduledTask: async (body) => {
        const params = parseInput(FeedsSchemas.runScheduledTaskSchema, body);
        const res = await http.post('/v2/feeds/scheduled-task/run', { body: params });
        return res;
    },
    deleteScheduledTaskData: async (body) => {
        const params = parseInput(FeedsSchemas.deleteScheduledTaskDataSchema, body);
        const res = await http.post(`/v2/feeds/scheduled-task/delete`, {
            body: params,
        });
        return res;
    },
}));
